import { render, staticRenderFns } from "./HomeWorkPage.vue?vue&type=template&id=1fb9eeb4"
import script from "./HomeWorkPage.vue?vue&type=script&lang=js"
export * from "./HomeWorkPage.vue?vue&type=script&lang=js"
import style0 from "./HomeWorkPage.vue?vue&type=style&index=0&id=1fb9eeb4&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports